import * as Sentry from '@sentry/react';
import { ApiSdk } from '@/httpclient';
import { HIDE_MESSAGE_401_PARAMS } from '@/config';

const accessTokenKey = 'gl-token-id';
const refreshTokenKey = 'gl-rtoken-id';

interface LoginInfo {
  token: string;
  userId: string;
}
class AuthService {
  redirect2LogoutPage = () => {
    window.location.href = '/cms/login';
  };
  clearInfoWhenLogout = async () => {
    try {
      await ApiSdk.UserService.logoff({ params: { [HIDE_MESSAGE_401_PARAMS]: true } });
    } catch (error) {}
    this.clearOnLogout();
  };
  clearOnLogout = () => {
    localStorage.removeItem(accessTokenKey);
    localStorage.removeItem(refreshTokenKey);
  };
  getAccessToken = () => {
    try {
      const info: LoginInfo | null = JSON.parse(localStorage.getItem(accessTokenKey) || '');
      return info?.token;
    } catch (error) {
      return null;
    }
  };
  getLoginInfo = () => {
    try {
      const info: LoginInfo | null = JSON.parse(localStorage.getItem(accessTokenKey) || '');
      return info;
    } catch (error) {
      return null;
    }
  };
  saveLoginInfo = (info: LoginInfo) => {
    localStorage.setItem(accessTokenKey, JSON.stringify(info));
  };

  saveRefreshToken = (token: string) => {
    localStorage.setItem(refreshTokenKey, token);
  };
  getRefreshToken = () => {
    return localStorage.getItem(refreshTokenKey);
  };
  logUserInfo2Sentry = (userId: string | undefined, email: string | undefined, username: string | undefined) => {
    Sentry.setUser({ id: userId, email: email, username: username });
  };
}

export default new AuthService();
